import { useContext } from 'react';

import { SessionDataContext } from './SessionDataContext';
import { getRovoEntitlementValues } from './getRovoEntitlementValues';

/**
 * This a temporary hook to support the Rovo performance experiment.
 * It works the same way as `useSessionData`, but overrides isRovoEnabled and isRovoLLMEnabled based on the experiment.
 *
 * https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/rovo_team25_rollout_performance_exp
 */
export const useSessionDataWithRovoExperiment = () => {
	const sessionData = useContext(SessionDataContext);
	const { isRovoEnabled, isRovoLLMEnabled } = sessionData;
	const overriddenRovoEntitlementValues = getRovoEntitlementValues({
		isRovoEnabledInTCS: isRovoEnabled,
		isRovoLLMEnabledInTCS: isRovoLLMEnabled,
	});

	return {
		...sessionData,
		...overriddenRovoEntitlementValues,
	};
};
